import {
  DATA_URL, DEFECTS_URL, GO_URL,
  MAP_URL,
  ORDERS_URL,
  REPORTS_URL, SETTINGS_URL,
  TASKS_URL
} from './url.config';
import { ToolbarMenu } from '../model/general.model';

export const API_URL = '/api';
export const HISTORICAL_FAILURES_LOCATION_RADIUS_METERS = 2;
export const PROJECTS_API = API_URL + '/projects';
export enum Lang {
  PL = 'pl'
}

// automatycznie przedłużenie sesji po wykonaniu requestu api nastąpi
// po upływie SESSION_AUTO_REFRESH_ELAPSED_RATIO czasu trwania sesji
export const SESSION_AUTO_REFRESH_ELAPSED_RATIO = 0.4;

export const LOCAL_STORAGE_KEYS = {
  engoSelectedProject: 'engoSelectedProject',
  loggedIn: 'loggedIn',
  projects: 'projects',
  user: 'user',
  permissions: 'permissions',
  buildInfo: 'buildInfo',

}

export const SECONDS_BEFORE_SESSION_ALERT = 120;

export const ORDERS_MENU_ITEM: ToolbarMenu = {
  labelKey: 'ORDERS.LABEL',
  icon: 'list_alt',
  link: ORDERS_URL
}

export const TASKS_MENU_ITEM: ToolbarMenu = {
  labelKey: 'TASKS.LABEL',
  icon: 'task_alt',
  link: `${GO_URL}/${TASKS_URL}`
}

export const DEFECTS_MENU_ITEM: ToolbarMenu = {
  labelKey: 'DEFECTS.LABEL',
  icon: 'bug_report',
  link: DEFECTS_URL
}

export const MAP_MENU_ITEM: ToolbarMenu = {
  labelKey: 'MAP',
  icon: 'map',
  link: MAP_URL
}

export const REPORTS_MENU_ITEM: ToolbarMenu = {
  labelKey: 'REPORTS.LABEL',
  icon: 'bar_chart',
  link: REPORTS_URL
}

export const SETTINGS_MENU_ITEM: ToolbarMenu = {
  labelKey: 'SETTINGS.LABEL',
  icon: 'settings',
  link: SETTINGS_URL
}

export const DATA_MENU_ITEM: ToolbarMenu = {
  labelKey: 'DATA.LABEL',
  icon: 'source',
  link: DATA_URL
}

export const PALETTE = {
  GREEN: "rgba(76, 175, 80, 1)",
  ORANGE: "rgba(255, 152, 0, 1)",
  DEEP_ORANGE: "rgba(255, 87, 34, 1)",
  AMBER: "rgba(255, 193, 7, 1)",
  RED: "rgba(244, 67, 54, 1)",
  PINK: "rgba(233, 30, 99, 1)",
  BLUE: "rgba(33, 150, 243, 1)",
  PURPLE: "rgba(156, 39, 176, 1)",
  DEEP_PURPLE: "rgba(103, 58, 183, 1)",
  INDIGO: "rgba(63, 81, 181, 1)",
  LIGHT_BLUE: "rgba(3, 169, 244, 1)",
  TEAL: "rgba(0, 150, 136, 1)",
  BROWN: "rgba(121, 85, 72, 1)",
  GREY: "rgba(158, 158, 158, 1)",
  BLUE_GREY: "rgba(96, 125, 139, 1)",
  LIME: "rgba(205, 220, 57, 1)",
  CYAN: "rgba(0, 188, 212, 1)",
  GREEN_OPACITY: "rgba(76, 175, 80, 0.3)",
  ORANGE_OPACITY: "rgba(255, 152, 0, 0.5)",
  DEEP_ORANGE_OPACITY: "rgba(255, 87, 34, 0.5)",
  AMBER_OPACITY: "rgba(255, 193, 7, 0.5)",
  RED_OPACITY: "rgba(244, 67, 54, 0.5)",
  PINK_OPACITY: "rgba(233, 30, 99, 0.3)",
  BLUE_OPACITY: "rgba(33, 150, 243, 0.5)",
  PURPLE_OPACITY: "rgba(156, 39, 176, 0.5)",
  DEEP_PURPLE_OPACITY: "rgba(103, 58, 183, 0.5)",
  INDIGO_OPACITY: "rgba(63, 81, 181, 0.5)",
  LIGHT_BLUE_OPACITY: "rgba(3, 169, 244, 0.5)",
  TEAL_OPACITY: "rgba(0, 150, 136, 0.5)",
  BROWN_OPACITY: "rgba(121, 85, 72, 0.5)",
  GREY_OPACITY: "rgba(158, 158, 158, 0.5)",
  BLUE_GREY_OPACITY: "rgba(96, 125, 139, 0.5)",
  LIME_OPACITY: "rgba(205, 220, 57, 0.5)",
  CYAN_OPACITY: "rgba(0, 188, 212, 0.5)",
  BLACK: "rgba(0, 0, 0)",
  YELLOW: "#FFEB3B",
  WHITE: "#FFF"
};

export const PHOTO_CONSTRAINTS = {
  MIN_RES_MPX: 4,
  MAX_RES_MPX: 12,
  TYPES_ALLOWED: ['jpg', 'jpeg', 'png']
}
